var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRestream(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 33,
    viewBox: "0 0 21 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4206 15.7155L15.4193 15.7153C14.3048 15.4879 13.3249 14.833 12.6931 13.8935C12.0612 12.9542 11.8286 11.8065 12.045 10.7002C12.2706 9.58915 12.9267 8.61113 13.8725 7.97653C14.8181 7.342 15.9781 7.10144 17.1032 7.30682C17.6609 7.4175 18.1913 7.63716 18.6631 7.95295C19.1355 8.26898 19.5398 8.67495 19.8525 9.14713L19.9866 9.05852L19.8527 9.14713C20.1656 9.61932 20.3807 10.1483 20.4855 10.7031C20.5905 11.258 20.5831 11.8277 20.4638 12.379L20.463 12.3835C20.3599 12.9346 20.1467 13.4594 19.836 13.927C19.5252 14.3946 19.1231 14.7955 18.6532 15.1061L18.7419 15.24L18.6532 15.1061C18.1834 15.4167 17.6553 15.6306 17.1 15.7353L17.1299 15.8931L17.1 15.7353C16.5448 15.84 15.9738 15.8333 15.4206 15.7155Z",
    fill: "url(#paint0_linear_1542_2501)",
    stroke: "url(#paint1_linear_1542_2501)",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.06697 9.15551C6.13836 9.5326 6.13337 9.91978 6.05218 10.2945L5.63691 8.0982C5.84961 8.419 5.99575 8.77843 6.06697 9.15551ZM6.06697 9.15551L5.9091 9.18531L6.06697 9.15551ZM6.06697 9.15551L5.9091 9.18531L6.06697 9.15551ZM5.9091 9.18531C5.84174 8.82928 5.70363 8.48984 5.50283 8.18683C5.30219 7.88379 5.0427 7.62324 4.73949 7.42039C4.43675 7.21777 4.09639 7.07681 3.73852 7.00573C3.01617 6.87398 2.27165 7.0285 1.66458 7.43578C1.0575 7.84316 0.636432 8.4709 0.491577 9.18396C0.352671 9.89374 0.502036 10.6302 0.907501 11.233C1.31313 11.836 1.94207 12.2565 2.6575 12.4024L2.65895 12.4027C3.01393 12.4783 3.38032 12.4826 3.73659 12.4154C4.09286 12.3482 4.43177 12.2109 4.73322 12.0116C5.03467 11.8123 5.2927 11.5551 5.49206 11.2552L5.62598 11.344L5.49206 11.2552C5.69142 10.9552 5.82823 10.6186 5.89415 10.2651L5.8951 10.2606L5.9091 9.18531Z",
    fill: "url(#paint2_linear_1542_2501)",
    stroke: "url(#paint3_linear_1542_2501)",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6931 23.6652C18.7452 23.941 18.7417 24.2241 18.6823 24.498L18.3786 22.8922C18.5341 23.1268 18.641 23.3895 18.6931 23.6652ZM18.6931 23.6652L18.5352 23.6951L18.6931 23.6652ZM18.6931 23.6652L18.5352 23.6951L18.6931 23.6652ZM18.5352 23.6951C18.487 23.4404 18.3883 23.1976 18.2446 22.9808C18.101 22.764 17.9153 22.5776 17.6984 22.4324C17.4819 22.2875 17.2386 22.1867 16.9825 22.1358C16.4656 22.0416 15.9327 22.1523 15.4984 22.4437C15.0639 22.7351 14.7626 23.1843 14.659 23.6945C14.5597 24.2021 14.6666 24.7289 14.9566 25.1601C15.2468 25.5916 15.6968 25.8925 16.2089 25.9969L16.2103 25.9972C16.4642 26.0513 16.7264 26.0544 16.9812 26.0064C17.236 25.9582 17.4785 25.8601 17.6941 25.7175C17.9097 25.575 18.0942 25.391 18.2367 25.1766L18.3708 25.2654L18.2367 25.1766C18.3793 24.9621 18.477 24.7214 18.5243 24.4686L18.5251 24.4641L18.5352 23.6951Z",
    fill: "url(#paint4_linear_1542_2501)",
    stroke: "url(#paint5_linear_1542_2501)",
    strokeWidth: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1542_2501",
    x1: 20.566,
    y1: 9.47292,
    x2: 10.7742,
    y2: 7.84317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7372B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17FE8",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1542_2501",
    x1: 20.566,
    y1: 9.47292,
    x2: 10.7742,
    y2: 7.84317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7372B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17FE8",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1542_2501",
    x1: 6.01633,
    y1: 8.36952,
    x2: -0.394992,
    y2: 7.30245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7372B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17FE8",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1542_2501",
    x1: 6.01633,
    y1: 8.36952,
    x2: -0.394992,
    y2: 7.30245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7372B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17FE8",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1542_2501",
    x1: 18.656,
    y1: 23.0905,
    x2: 13.9683,
    y2: 22.3104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7372B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17FE8",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1542_2501",
    x1: 18.656,
    y1: 23.0905,
    x2: 13.9683,
    y2: 22.3104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7372B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17FE8",
    stopOpacity: 0.2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestream);
export default __webpack_public_path__ + "static/media/restream.8ce2c0702d0b3b06f27725536573e82c.svg";
export { ForwardRef as ReactComponent };